import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
} from "@mui/material";
import StyledTextField from "../shared/StyledTextField";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  text,
  showInput = false,
  maxQuantity = 0,
}) => {
  const [quantity, setQuantity] = useState(1);

  // Resetar a quantidade toda vez que o modal abrir
  useEffect(() => {
    if (open) setQuantity(maxQuantity || 1);
  }, [open, maxQuantity]);

  const handleConfirm = () => {
    // Passamos a quantidade de volta na confirmação
    onConfirm(showInput ? quantity : null);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmação</DialogTitle>
      <DialogContent>
        <p>{text}</p>

        {showInput && (
          <Box sx={{ mt: 1 }}>
            <StyledTextField
              label="Quantidade para remover"
              type="number"
              value={quantity}
              onChange={(e) => {
                const val = Math.max(
                  1,
                  Math.min(maxQuantity, Number(e.target.value)),
                );
                setQuantity(val);
              }}
              inputProps={{ min: 1, max: maxQuantity }}
              helperText={`Máximo disponível: ${maxQuantity}`}
              autoFocus
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          disabled={showInput && (quantity <= 0 || quantity > maxQuantity)}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
